import React, { useState, useEffect, useRef } from "react";
import "./News.css";
import Nav from "../Nav/Nav";
import NewsSection from "../NewsSection/NewsSection";
import LogoLoader from "../Loading/Loading";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Footer from "../Footer/Footer";
import newsData from "../../data/news.json";

const News = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const targetId = searchParams.get("targetId") || location.state?.targetId;

  const [news, setNews] = useState([]);

  useEffect(() => {
    if (newsData && newsData.length > 0) {
      const randomIndex = Math.floor(Math.random() * newsData.length);
      setNews(newsData[randomIndex]);
    }
  }, []);

  useEffect(() => {
    if (!isLoading && targetId) {
      const timeout = setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [isLoading, targetId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2650);

    return () => clearTimeout(timer);
  }, []);

  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem("language", JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <LogoLoader />
      </div>
    );
  }

  return (
    <>
      <div className="news-container-up">
        <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
        <div className="news-container">
          <img
            src={news.news_image_url}
            alt="news-photo"
            className="news-image"
          />
          <div className="overlay">
            <div className="vertical-line left"></div>
            <div className="vertical-line right"></div>
            <div className="hero-title">
              <h1 className="overlay-text">
                {"  "}
                <strong>
                  <span class="protest-font"></span>
                  <img
                    src="/underlined2-1.png"
                    alt="Underline decoration"
                    className="underline-image"
                  />
                </strong>{" "}
              </h1>
            </div>
            <div className="bottom-line"></div>
          </div>
        </div>
        <div id="newsSection">
          <NewsSection isAlbanian={isAlbanian} />
        </div>
      </div>
      <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default News;
